
import * as ApiWithToken from "../callApiWithToken";

const surveyAppointmentService = {
    getSurveyByAppointment: async function (appointmentId: number) {
        return ApiWithToken.getApi(process.env.REACT_APP_SURVEY_API + `SurveyAppointment?appointmentId=${appointmentId}`);
    },
}
export default surveyAppointmentService;
